import { useEffect, useState } from 'react';
import DialBackSEO from './components/DialBackSEO';
import DialBackNav from './components/DialBackNav';
import DialBackHero from './components/DialBackHero';
import DialBackPain from './components/DialBackPain';
import DialBackComparison from './components/DialBackComparison';
import DialBackHowItWorks from './components/DialBackHowItWorks';
import DialBackRoadmap from './components/DialBackRoadmap';
import DialBackPricing from './components/DialBackPricing';
import DialBackBeta from './components/DialBackBeta';
import DialBackCTA from './components/DialBackCTA';
import DialBackFooter from './components/DialBackFooter';
import WaitlistModal from './components/WaitlistModal';

export default function DialBackPage() {
  const [waitlistOpen, setWaitlistOpen] = useState(false);

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href =
      'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400&family=DM+Mono:wght@400;500&family=Instrument+Sans:wght@400;500;600&display=swap';
    document.head.appendChild(link);

    const style = document.createElement('style');
    style.textContent = `
      @keyframes fadeUp {
        from { opacity: 0; transform: translateY(20px); }
        to { opacity: 1; transform: translateY(0); }
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(link);
      document.head.removeChild(style);
    };
  }, []);

  const openWaitlist = () => setWaitlistOpen(true);
  const closeWaitlist = () => setWaitlistOpen(false);

  return (
    <div className="bg-[#0e0d0b] text-[#f5f2ec] overflow-x-hidden">
      <DialBackSEO />
      <DialBackNav onJoinBeta={openWaitlist} />
      <DialBackHero onGetAccess={openWaitlist} />
      <DialBackPain />
      <DialBackComparison />
      <DialBackHowItWorks />
      <DialBackRoadmap />
      <DialBackPricing onGetAccess={openWaitlist} />
      <DialBackBeta />
      <DialBackCTA onGetAccess={openWaitlist} />
      <DialBackFooter />
      <WaitlistModal open={waitlistOpen} onClose={closeWaitlist} />
    </div>
  );
}
